import axios from 'axios'
const http = axios.create({
  baseURL: window.indexBaseURL+'/reportapi',
  // 请求 30s 超时
  timeout: 300000,
  headers: {
    post: {
      'Content-Type': 'application/json;charset=utf-8'
      // 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
      // 在开发中，一般还需要单点登录或者其他功能的通用请求头，可以一并配置进来
    },
    get: {
      // 'Content-Type': 'application/json;charset=utf-8'
      // 在开发中，一般还需要单点登录或者其他功能的通用请求头，可以一并配置进来
    }
  }
})
// 请求拦截器
// http.interceptors.request.use((config) => {
//   // console.log(config)
//   // console.log('进入请求拦截')
//   if (getToken()) {
//     // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
//     config.headers.Authorization = getToken()
//   }
//   return config
// }, (error) => {
//   // 错误抛到业务代码
//   error.data = {}
//   error.data.msg = '服务器异常，请联系管理员！'
//   return Promise.resolve(error)
// })

// 响应拦截器
// http.interceptors.response.use((response) => {
//   // console.log(response)
//   if (response.data.code === 301) {
//     return router.replace('/power')
//   } else {
//     return response
//   }
// }, (error) => {
//   // 错误抛到业务代码
//   error.data = {}
//   error.data.msg = '请求超时或服务器异常，请检查网络或联系管理员！'
//   return Promise.resolve(error)
// })




export default http
